import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import LargeHeading from '../components/LargeHeading';
import AwardeeCard from '../components/AwardeeCard';
import ButtonSmall from '../components/ButtonSmall';
import Loader from '../components/Loader';
import Awardee from './Awardee';
import LazyImageLoader from '../components/LazyImageLoader';


const Gallery = () => {
    const [albumsloader, setAlbumsloader] = useState(true);
    const [galleryloader, setGalleryloader] = useState(true);
    const [gallerydetails, setGallerydetails] = useState([]);
    // const [awardname, setAwardname] = useState(String);
    // const { awardSlug } = useParams(); 
    // console.log(awardSlug);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Smooth scrolling animation
        });
    }

    const getGallery = () => {
        axios.get(`wp/v2/gallery?acf_format=standard&per_page=99&acf_format=standard`)
            .then((response) => {
                // console.log("running");
                const awardeedataloader = response.data.map(item => {
                    // console.log(item);
                    return {
                        name: item.title.rendered,
                        image: item.acf.cover_image,
                        year: item.acf.awardee_year,
                        slug: item.slug
                    }
                });
                // console.log(awardeedataloader);
                setGallerydetails(awardeedataloader);
                setGalleryloader(false);
            })
            .catch((error) => {
                console.error(error);
            });
        // setGalleryloader(false);
    }

    useEffect(() => {
        setAlbumsloader(true);
        setAlbumsloader(true);
        // console.log("new page data loaded")
        getGallery();

    }, [])

    return (
        <>
            {
                (galleryloader === true && albumsloader === true) ? <Loader /> :
                    <>
                        <div>
                            <Helmet>
                                <title>Gallery - Polymer Processing Society</title>
                            </Helmet>
                        </div>
                        <div className='page-container'>
                            <div className='outer-section text-center'>
                                <LargeHeading title={"Gallery"} />
                            </div>
                            <div className='inner-section'>
                                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-[10px] special-margin">
                                    {gallerydetails.map(gallery => (
                                        <div
                                            key={gallery.slug}
                                            className="flex flex-col items-center"
                                        >
                                            <LazyImageLoader className="m-2" src={gallery.image} alt="awardee_image" />
                                            <p className="text-center text">{gallery.name}</p>
                                            <Link to={`/gallery/${gallery.slug}`}>
                                                <button
                                                    onClick={scrollToTop}
                                                    className="rounded-[3px] bg-[#5C469C] px-[5px] py-[2px] flex"
                                                >
                                                    <p className="text-small-inverse">Details</p>
                                                </button>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>
    )
}

export default Gallery